import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
function DataTableTemplate({
  list,
  lazyState,
  totalRecords,
  setlazyState,
  columns,
  setDefaultDatatableRows,
  defaultDatatableRows,
  width,
  rowClick,
  // setSelectedProducts,
  // selectedProducts,
  select,
  className,
  dataKey,
  header,
  onFilter,
  paginator = true,
  filters,
  onPage,
  sortOrder,
  onSort,
  sortField
}) {
  return (
    <DataTable
      filterDisplay={"menu"}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate=" ({totalRecords}) تعداد کل "
      // selection={selectedProducts}
      // onSelectionChange={(e) => setSelectedProducts&& setSelectedProducts(e.value)}
      rowHover={true}
      className="table-border"
      header={header}
      value={list}
      tableStyle={{ minWidth: width }}
      stripedRows
      size="Normal"
      rows={defaultDatatableRows}
      dataKey={dataKey}
      paginator={paginator}
      first={lazyState.first}
      emptyMessage="موردی یافت نشد."
      lazy
      totalRecords={totalRecords}
      rowsPerPageOptions={[5, 10, 25, 50]}
      onPage={onPage}
      width={width}
      filters={filters}
      onFilter={onFilter}
      onSort={onSort}
      sortOrder={sortOrder}
      sortField={sortField}
    >
      {select && (
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
      )}
      {columns.map((column, index) => (
        <Column
          {...column}
          key={index}
          field={column.field}
          header={column.header}
          body={column.body}
          className={column.className}
        ></Column>
      ))}
    </DataTable>
  );
}

export default DataTableTemplate;
